<div class="main-page">
  <nav class="navbar navbar-expand-lg navbar-light bg-light header">
    <div class="logo"><a (click)="redirectTo(2)"><img src="assets/logo-4.png"></a></div>
  </nav>
  <div class="container">
    <div class="add-advertisement-top">
      <div class="innerPage add-advertisement-area">
        <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
        <div class="setting-screen-area"><span class="nav-divnk">Create Advertisement</span></div>
        <!-- <div class="content-part"><img src="assets/logo-5.png"></div> -->
        <div class="sin-in-contnt">
          <div class="ad-image">
            <img [src]="checkImage(imagePath) ? checkImage(imagePath):'assets/imageplaceholder.jpeg'" alt="test">
            <div class="upload-btn-wrapper">
              <button class="btn" (click)="openInfo(gallery)">Choose from Gallery</button>
              <button class="btn" (click)="fileInput.click()">Upload Custom Image</button>
              <input #fileInput type="file" accept="image/*" style="display:none" (change)="onFileSelect($event)" />
            </div>
          </div>
          <form class="form-signin" [formGroup]="form">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Ad Heading</label>
                  <input type="text" class="form-control" formControlName="title" placeholder="Heading"
                    [ngClass]="{ 'is-invalid': submitted && f.title.errors}">
                  <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                    <div class="error" *ngIf="f.title.errors.required">Name is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group ">
                  <label>Ad Details</label>
                  <textarea type="text" class="form-control" formControlName="description" placeholder="Description"
                    style="min-height: 90px;"></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group  md-outline">
                  <label>Limited-time offer? Select the date range (optional)</label>
                  <input bsDatepicker formControlName="startDate" class="form-control" type="text"
                    placeholder="Start Date (optional)">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group  md-outline">
                  <label>Ad Location</label>
                  <input type="text" formControlName="location" class=" location-field form-control"
                    placeholder="Choose Location & Pricing" (click)="addAdddress()"
                    [ngClass]="{ 'is-invalid': submitted && f.location.errors }" />
                  <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                    <div class="error" *ngIf="f.location.errors.required">Required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="">
                  <label>Limited-time offer ends (optional)</label>
                  <input bsDatepicker formControlName="endDate" class="form-control" type="text"
                    placeholder="End Date (optional)">
                </div>
              </div>
              <div class="col-md-6" style="margin-top: auto;">
                <button (click)="onSubmit(form.value)" type="submit" class="next-button btn btn-primary">Next</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #gallery let-modal>
  <div class="modal-header">
    <div class="row">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
        <div type="button" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span style="float:right" aria-hidden="true">X</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div *ngIf="images && images.length > 1">
      <div *ngFor="let image of images" class="main-row">
        <div class="column">
          <img [src]="checkImage(image.url)" (click)="selectImageFrom(image.url)">
        </div>
      </div>
      <div class="load-more-row" *ngIf="images && images.length > 10">
        <button class="btn load-more" (click)="getGallery()">Load More</button>
      </div>
    </div>
    <div *ngIf="!isImages" class="no-data">
      <h5>No Data Found</h5><br>
      <div>For this, upload photos in your photo gallery.</div>
    </div>
  </div>
</ng-template>